import { render, staticRenderFns } from "./TokenPower.vue?vue&type=template&id=7f28b8fb&scoped=true"
import script from "./TokenPower.vue?vue&type=script&lang=js"
export * from "./TokenPower.vue?vue&type=script&lang=js"
import style0 from "./TokenPower.vue?vue&type=style&index=0&id=7f28b8fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f28b8fb",
  null
  
)

export default component.exports